module.exports = __webpack_public_path__ + "img/4.ba9b32d2.jpg";